import { Container, Stack, Title } from "@mantine/core";
import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";

import { SessionsSection } from "../features/sessions/SessionsSection";

// Страница «Настройки → Сессии». Тонкий контейнер над секцией
// управления своими сессиями (remember-me, список активных, отзыв) —
// как `ReviewerChecklistPage`.
export function SettingsSessionsPage(): ReactElement {
  const { t } = useTranslation();
  return (
    <Container py="xl">
      <Stack gap="xl">
        <Title order={1}>{t("sessions.pageTitle")}</Title>
        <SessionsSection />
      </Stack>
    </Container>
  );
}
